module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAYCAYAAACFms+HAAAAAXNSR0IArs4c6QAAATFJREFUWAnVlkEOgjAQRcEYwjVk61XgEizgCLL1CCyBBO6gnodzGEKCvyZNwAxOgYaWbtTpZHgzebQ6jqZVVdWlKIqHpnJsmTObwSQ0TeP3fX8bhiFDqs+ka9veBF6WZdh1XQ6aQBuRYqFV4HVdB5hyjimHis/RnrYIXGoB6AzQu2lBda0MblKLVeA2aLEI3CYtKHCXCgot4LCR04LioWITcFu1mAWXWohLxPRpQUFSMfcIWlDgJyxXLGrT5tgXWKiCqzsDv/jPYfRiUR3WZNKHezl/uzyC95OJjxtYq0+aprM1x/W3fmcfslSfvcBPXOdxHLdJkkR4cSPktlz+XvssuAQB/MvzvCt+39HEW8ZNfbKqUGD/9LFGFQrcBn2UVaEasE0fipGNCX1w/j/ZRE0JH599rKcOpUICAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/examtest_icon_prev.png
// module id = 4+G4
// module chunks = 0